/** Public signup modes for training groups (Anmälningar). */
export const REGISTRATION_MODES = {
  NONE: 'none',
  DIRECT_PAYMENT: 'direct_payment',
  DIRECT_TRIAL: 'direct_trial',
  DIRECT_FREE: 'direct_free',
  INTEREST_REVIEW: 'interest_review',
  INFO_ONLY: 'info_only',
};

export const REGISTRATION_MODE_ORDER = [
  REGISTRATION_MODES.NONE,
  REGISTRATION_MODES.DIRECT_PAYMENT,
  REGISTRATION_MODES.DIRECT_TRIAL,
  REGISTRATION_MODES.DIRECT_FREE,
  REGISTRATION_MODES.INTEREST_REVIEW,
  REGISTRATION_MODES.INFO_ONLY,
];

export const REGISTRATION_MODE_LABEL_KEYS = {
  [REGISTRATION_MODES.NONE]: 'anmalningar_mode_none',
  [REGISTRATION_MODES.DIRECT_PAYMENT]: 'anmalningar_mode_direct_payment',
  [REGISTRATION_MODES.DIRECT_TRIAL]: 'anmalningar_mode_direct_trial',
  [REGISTRATION_MODES.DIRECT_FREE]: 'anmalningar_mode_direct_free',
  [REGISTRATION_MODES.INTEREST_REVIEW]: 'anmalningar_mode_interest_review',
  [REGISTRATION_MODES.INFO_ONLY]: 'anmalningar_mode_info_only',
};

export const REGISTRATION_MODE_DESC_KEYS = {
  [REGISTRATION_MODES.NONE]: 'anmalningar_mode_none_desc',
  [REGISTRATION_MODES.DIRECT_PAYMENT]: 'anmalningar_mode_direct_payment_desc',
  [REGISTRATION_MODES.DIRECT_TRIAL]: 'anmalningar_mode_direct_trial_desc',
  [REGISTRATION_MODES.DIRECT_FREE]: 'anmalningar_mode_direct_free_desc',
  [REGISTRATION_MODES.INTEREST_REVIEW]: 'anmalningar_mode_interest_review_desc',
  [REGISTRATION_MODES.INFO_ONLY]: 'anmalningar_mode_info_only_desc',
};

/**
 * @param {unknown} raw
 * @returns {string}
 */
export function normalizeRegistrationMode(raw) {
  const mode = String(raw ?? REGISTRATION_MODES.NONE).trim();
  return REGISTRATION_MODE_ORDER.includes(mode) ? mode : REGISTRATION_MODES.NONE;
}

/**
 * @param {string} mode
 * @returns {boolean}
 */
export function registrationModeAllowsPublicListing(mode) {
  return normalizeRegistrationMode(mode) !== REGISTRATION_MODES.NONE;
}

/**
 * @param {string} mode
 * @returns {boolean}
 */
export function registrationModeAllowsSignup(mode) {
  const m = normalizeRegistrationMode(mode);
  return m !== REGISTRATION_MODES.NONE && m !== REGISTRATION_MODES.INFO_ONLY;
}

/**
 * @param {object|null|undefined} group
 * @returns {boolean}
 */
export function isGroupPublicRegistrationVisible(group) {
  if (!group) return false;
  const mode = normalizeRegistrationMode(group.registrationMode);
  if (mode === REGISTRATION_MODES.NONE) return false;
  return Boolean(group.registrationPublicVisible);
}
